// extracted by mini-css-extract-plugin
module.exports = {"default":"text-box-grid_default__3Tuo1"};